import { useMemo, useState } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/base/Seo";
import PageHeader from "@/components/feature/PageHeader";
import RealisationCard from "./components/RealisationCard";
import CallToAction from "@/pages/home/components/CallToAction";
import { useCollection } from "@/hooks/useCollection";
import type { Realisation } from "@/lib/types";

const realisationsHeroImage =
  "https://readdy.ai/api/search-image?query=Warm%20editorial%20wide%20photograph%20of%20volunteers%20celebrating%20together%20with%20raised%20hands%20and%20smiles%20after%20a%20successful%20humanitarian%20mission%20in%20an%20African%20village%2C%20joyful%20solidarity%20atmosphere%2C%20soft%20natural%20light%2C%20premium%20humanitarian%20photography%2C%20high%20detail&width=1600&height=500&seq=humanity59-realisations-hero&orientation=landscape&nocache=true";

export default function Realisations() {
  const { items } = useCollection<Realisation>("realisations");
  const [active, setActive] = useState("Toutes");

  const categories = useMemo(() => {
    const set = new Set<string>();
    items.forEach((item) => {
      if (item.category) set.add(item.category);
    });
    return ["Toutes", ...Array.from(set)];
  }, [items]);

  const filtered =
    active === "Toutes"
      ? items
      : items.filter((item) => item.category === active);

  return (
    <div className="min-h-screen flex flex-col">
      <Seo
        title="Nos réalisations | Humanity59"
        description="Retour en images sur les réalisations d'Humanity59 : événements, collectes et actions menées à bien au fil de la vie de l'association humanitaire."
        keywords="réalisations, événements, collectes, association humanitaire, solidarité"
        path="/realisations"
      />
      <Header />
      <main className="flex-1">
        <PageHeader
          title="Nos réalisations"
          subtitle="Retour en images sur les événements, collectes et actions qui ont marqué la vie de l'association."
          image={realisationsHeroImage}
        />

        {items.length > 0 && (
          <section className="py-16 md:py-24 bg-background-50">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex flex-wrap justify-center gap-2">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    type="button"
                    onClick={() => setActive(cat)}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                      active === cat
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-700 hover:bg-background-200"
                    }`}
                  >
                    {cat}
                  </button>
                ))}
              </div>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filtered.map((item) => (
                  <RealisationCard key={item.title} item={item} />
                ))}
              </div>
            </div>
          </section>
        )}

        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}